/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Auth from "../shared/Auth";
import Globals from "../shared/Globals";
import { qreq } from "../shared/qrequest";
import Alert from "./Alert";
import L from "./Lang"
import BaseCom from "./BaseCom";
import Card from "./Card";
import Icon from "./Icon";
import MedicalReleaseSendModal from "./MedicalReleaseSendModal";
import { Pop } from "./PopModal";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";

class MedicalRelease extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            showSendMedicalRelease: false
        };
        this.load = this.load.bind(this);
        this.delete = this.delete.bind(this);
    }

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(prevProps) {
        if (this.props.item !== prevProps.item && this.props.item?.id !== prevProps.item?.id)
            this.load();
    }

    load() {
        if (this.props.item && this.props.item.id) {
            qreq.get('/api/document/medical-release/list?orderID=' + this.props.item.id, j => {
                if (j.list)
                    this.setState({ list: j.list });
            });
        }
    }

    delete(item) {
        Pop.showConfirm(<><L>Are you sure you want to delete form sent on</L><br /><strong>{Globals.toMDYHMLocalDateString(item.sentDate)}</strong><L>?</L></>, 'Delete Form', () => {
            qreq.post('/api/document/medical-release/delete', { id: item.id }, j => {
                if (j.errorCode === 0) {
                    this.success('The form has been deleted.');
                    var list = this.state.list.filter(i => i.id !== item.id);
                    this.setState({ list: list });
                }
                else
                    this.alert(j.errorMessage);
            }, this.unkownErrorCallback);
        });
    }

    render() {
        if (!Auth.hasRole('manager'))
            return null;
        return <>
            <MedicalReleaseSendModal orderID={this.props.item?.id} emails={this.props.item?.referrer?.email} show={this.state.showSendMedicalRelease} onHide={() => { this.setState({ showSendMedicalRelease: false }); }} />
            <Card title="Medical Records Release">
                <button type="button" className="btn btn-primary" onClick={() => this.setState({ showSendMedicalRelease: true })}>Send Medical Records Release Form</button>
                <p><L>You will be asked for recipients on the next screen.</L></p>
                {this.state.list ? <table className="table table-striped">
                    <thead>
                        <tr>
                            <th></th>
                            <th><L>Sent</L></th>
                            <th className="d-none d-md-table-cell"><L>Recipients</L></th>
                            <th><L>Completed</L></th>
                            <th className="d-none d-md-table-cell"><L>Person/Organization</L></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.list.map((item, i) => <tr key={i}>
                            <td><a title="PDF" href={Globals.serverUrl + '/api/document/render/medical-release/' + item.id + '/' + this.props.item?.patient?.fullName?.replace(/[^a-zA-Z0-9]+/, '-') + '-medical-records-release-' + item.orgName?.replace(/[^a-zA-Z0-9]+/, '-') + '.pdf'} target="_blank" rel="noreferrer"><Icon icon="faFilePdf" /></a></td>
                            <td><a title="PDF" href={Globals.serverUrl + '/api/document/render/medical-release/' + item.id + '/' + this.props.item?.patient?.fullName?.replace(/[^a-zA-Z0-9]+/, '-') + '-medical-records-release-' + item.orgName?.replace(/[^a-zA-Z0-9]+/, '-') + '.pdf'} target="_blank" rel="noreferrer">{Globals.toMDYHMLocalDateString(item.sentDate)}</a></td>
                            <td className="d-none d-md-table-cell">{item.emails}{item.sendPhone ? ', ' + item.sendPhone : ''}</td>
                            <td>{item.isFilled ? item.filledDate : 'No'}</td>
                            <td className="d-none d-md-table-cell">{item.orgName ?? 'Not Completed'}</td>
                            <td>{!item.isFilled ? <span role="button" className="text-danger" title="Delete" onClick={() => this.delete(item)}><Icon icon="faTrash" /></span> : null}</td>
                        </tr>)}
                    </tbody>
                </table> : <p className="fs-italic"><L>No medical records release forms have been sent yet.</L></p>}
            </Card>
        </>;
    }
}

export default withParamsAndNavigate(MedicalRelease);